import { effectiveMinMaxDate } from './planEffectiveDate';

describe('effectiveMinMaxDate', () => {
  it('no SafeHarbor date is after 9/20', () => {
    Date.now = jest.fn(() => new Date('2024-09-20T12:33:37.000Z'));
    expect(effectiveMinMaxDate(false).min).toEqual('2024-10-11');
    expect(effectiveMinMaxDate().max).toEqual('2029-09-20');
  });
  it('with SafeHarbor date is before 9/20', () => {
    Date.now = jest.fn(() => new Date('2024-09-19T12:33:37.000Z'));
    expect(effectiveMinMaxDate(true).min).toEqual('2024-10-10');
    expect(effectiveMinMaxDate().max).toEqual('2029-09-19');
  });
  it('with SafeHarbor date is 9/20', () => {
    Date.now = jest.fn(() => new Date('2024-09-20T12:33:37.000Z'));
    expect(effectiveMinMaxDate(true).min).toEqual('2024-10-01');
    expect(effectiveMinMaxDate().max).toEqual('2029-09-20');
  });
  it('with SafeHarbor date is after 9/20', () => {
    Date.now = jest.fn(() => new Date('2024-09-21T12:33:37.000Z'));
    expect(effectiveMinMaxDate(true).min).toEqual('2025-01-01');
    expect(effectiveMinMaxDate().max).toEqual('2029-09-21');
  });
});
